/**
 * The year's timetable template (CA-20, CA-21).
 *
 * The headers core/timetable-import.js reads — required, the optional
 * `ukedag` after the date, jumu'ah last — in the order the day runs. One row
 * per day, date and weekday filled in, times empty; a BOM and semicolons so
 * Norwegian Excel opens it as columns on a double-click.
 */
import { WEEKDAY_LONG, isoToday } from './format';

const TT_HEADERS = ['dato', 'ukedag', 'fajr_begynner', 'soloppgang', 'dhuhr_begynner', 'asr_begynner',
  'maghrib_begynner', 'isha_begynner', 'fajr_jamaat', 'dhuhr_jamaat', 'asr_jamaat', 'maghrib_jamaat',
  'isha_jamaat', 'jumua_khutbah', 'jumua_jamaat'];

export function templateCsv(year: number): string {
  const lines = [TT_HEADERS.join(';')];
  for (let d = new Date(year, 0, 1); d.getFullYear() === year; d.setDate(d.getDate() + 1)) {
    lines.push([isoToday(d), WEEKDAY_LONG[d.getDay()], ...Array(TT_HEADERS.length - 2).fill('')].join(';'));
  }
  return '\ufeff' + lines.join('\r\n') + '\r\n';
}
